/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-toggle-star-filled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 1.25L7.156 7.013.8 7.93l4.6 4.488-1.088 6.331L10 15.762l5.688 2.988-1.088-6.331 4.6-4.482-6.356-.925z" _fill="#000" fill-rule="evenodd"/>'
  }
})
